import React from 'react';
import styles from './AlButton.module.css'
import { CommonButton } from '_components'

export class BlankButton extends React.Component {
    render() {
        let cls;
        let font1;
        switch (this.props.size) {
            case "extra-small":
                cls = styles.button_extra_small;
                font1 = styles.font1_extra_small;
                break;
            case "smaller":
                cls = styles.button_smaller;
                font1 = styles.font1_smaller;
                break;
            case "small":
                cls = styles.button_small;
                font1 = styles.font1_small;
                break;
            case "medium":
                cls = styles.button_medium;
                font1 = styles.font1_medium;
                break;
            case "large":
                cls = styles.button_large;
                font1 = styles.font1_large;
                break;
            default:
                cls = styles.button_small;
                font1 = styles.font1_small;
                break;
        }

        if (this.props.className) {
            cls += ' ' + this.props.className;
        }

        cls = styles.button + ' ' + cls;

        return (
            <CommonButton title={this.props.title ? this.props.title : ''} onClick={this.props.onClick} size={this.props.size} className={cls} >
                {this.props.label &&
                    <span className={font1}>{this.props.label}</span>
                }
            </CommonButton>
        );



    }
}



